import script from "./RegisterByPhone.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterByPhone.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterByPhone.vue?vue&type=style&index=0&id=66e9145c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e9145c"]])

export default __exports__